Adds a process history item to an uploaded candidate's profile.
